import { render, staticRenderFns } from "./basic-layout.vue?vue&type=template&id=dd15f8ac&"
import script from "./basic-layout.vue?vue&type=script&lang=ts&"
export * from "./basic-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports